import { Button, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
} from "react-image-crop";
import "./ReactImageCrop.css";
import "react-image-crop/dist/ReactCrop.css";
import { UseDebounceEffect } from "./useDebounceEffect";
import { canvasPreview } from "./CanvasPreview";
import styles from "./index.module.scss";

function ImageCropper({ handleSubmit, isOpen, handleClose, imageData }) {
  const [imgSrc, setImgSrc] = useState(imageData);
  const previewCanvasRef = useRef(null);
  const imgRef = useRef(null);
  const inputRef = useRef(null);
  let hiddenAnchorRef = useRef(null);
  const blobUrlRef = useRef("");
  const [crop, setCrop] = useState();
  const [completedCrop, setCompletedCrop] = useState();
  const [scale, setScale] = useState(1);
  const [rotate, setRotate] = useState(0);
  const [aspect, setAspect] = useState(1 / 1);

  useEffect(() => {
    onSelectFile(imageData);
  }, [imageData]);

  function onSelectFile(e) {
    if (e) {
      setCrop(undefined); // Makes crop preview update between images.
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        setImgSrc(reader.result?.toString() || "")
      );
      reader.readAsDataURL(e);
    }
  }

  function onImageLoad(e) {
    if (aspect) {
      const { width, height } = e.currentTarget;
      setCrop(centerAspectCrop(width, height, aspect));
    }
  }

  function onDownloadCropClick() {
    if (!previewCanvasRef.current) {
      throw new Error("Crop canvas does not exist");
    }

    previewCanvasRef.current.toBlob((blob) => {
      if (!blob) {
        throw new Error("Failed to create blob");
      }
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current);
      }
      blobUrlRef.current = URL.createObjectURL(blob);
      hiddenAnchorRef.current.href = blobUrlRef.current;
      hiddenAnchorRef.current.click();
    });
  }

  UseDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        // We use canvasPreview as it's much faster than imgPreview.
        canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          scale,
          rotate
        );
      }
    },
    100,
    [completedCrop, scale, rotate]
  );

  function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
    return centerCrop(
      makeAspectCrop(
        {
          unit: "%",
          width: 90,
        },
        aspect,
        mediaWidth,
        mediaHeight
      ),
      mediaWidth,
      mediaHeight
    );
  }

  function handleClickAddImageButton() {
    inputRef?.current?.click();
  }

  function handleImageRotate() {
    setRotate((prev) => Number(prev) + 90);
  }

  function _handleSubmit() {
    if (!previewCanvasRef.current) {
      throw new Error("Crop canvas does not exist");
    }

    previewCanvasRef.current.toBlob((blob) => {
      if (!blob) {
        throw new Error("Failed to create blob");
      } else {
        handleSubmit(blob);
      }
    });
  }


  console.log(imgSrc);

  return (
    <Modal
      footer={false}
      closeIcon={<></>}
      open={isOpen}
      className={styles.image_cropper_modal}
    >
      <>
        {!imgSrc ? (
          <div className="Crop-Controls">
            <div className={styles.uploader_wrap}>
              <Button
                onClick={handleClickAddImageButton}
                className={styles.add_image_btn}
              >
                + Click here to upload image
              </Button>
            </div>

            {/* <div>
            <label htmlFor="rotate-input">Rotate: </label>
            <input
              id="rotate-input"
              type="number"
              value={rotate}
              disabled={!imgSrc}
              onChange={(e) =>
                setRotate(Math.min(180, Math.max(-180, Number(e.target.value))))
              }
            />
          </div> */}
          </div>
        ) : null}

        {!!imgSrc && (
          <>
            <div className={styles.cropper_body}>
              <ReactCrop
                crop={crop}
                onChange={(_, percentCrop) => setCrop(percentCrop)}
                onComplete={(c) => setCompletedCrop(c)}
                aspect={aspect}
              >
                <img
                  ref={imgRef}
                  alt="Crop me"
                  src={imgSrc}
                  style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }}
                  onLoad={onImageLoad}
                />
              </ReactCrop>
            </div>
            <div className={styles.image_actions_foooter}>
              <div className={styles.actions}>
                <button onClick={handleClickAddImageButton}>
                  <i class="fal fa-pencil" />
                  Change
                </button>
                <button
                  onClick={handleImageRotate}
                  className={styles.rotate_btn}
                >
                  <i class="fal fa-undo" />
                  Rotate
                </button>
              </div>
              <div className={styles.options}>
                <button className={styles.close_btn} onClick={handleClose}>
                  Close
                </button>
                <button className={styles.save_btn} onClick={_handleSubmit}>
                  Save
                </button>
              </div>
            </div>
          </>
        )}
        {!!completedCrop && (
          <>
            <div style={{ display: "none" }}>
              <canvas
                ref={previewCanvasRef}
                style={{
                  border: "1px solid black",
                  objectFit: "contain",
                  width: completedCrop.width,
                  height: completedCrop.height,
                }}
              />
            </div>
          </>
        )}
      </>
    </Modal>
  );
}

export default ImageCropper;
